import request from "../request";

export const getGrowthGoalsByStudentAndDR = (curriculumId, drId, studentId, questionId) =>
  request.get(`/assessment/${curriculumId}/growth-goals/developmental-rubric/${drId}/question/${questionId}/student/${studentId}`).then((res) => res);

export const createGrowthGoalsByStudentAndDR = (curriculumId, drId, studentId, questionId, data) =>
  request.post(`/assessment/${curriculumId}/growth-goals/developmental-rubric/${drId}/question/${questionId}/student/${studentId}`, data).then((res) => res);

export const deleteGrowthGoals = (curriculumId, id) =>
  request.delete(`/assessment/${curriculumId}/growth-goals/${id}`).then((res) => res);
